import { Nutshell } from '@nutshell/core';

/**
 * Default settings
 * Check /res/docs/index.html for the Nutshell docs
 */
Nutshell.options.ServerRequest.baseurl = window.location.href;
Nutshell.options.ServerRequest.secure = false;
Nutshell.options.ServerRequest.peanuts = false;
Nutshell.options.ServerRequest.status = 'header';

/**
 * Form Patterns
 */
Nutshell.options.Validator.custom.patterns['zipcode'] = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;

/**
 * Vue Application Config
 */
export const AppConfig = {
	mount: '#application',
	name: 'Reuzado'
}

/**
 * Export all configs
 */
export default {
	App: AppConfig
}
